import { ViolationTypeEnum } from '@fleet-beat/core';

export interface ViolationsDto {
  startedAt: string;
  endedAt: string;
  type: ViolationTypeEnum;
  id?: string;
  duration?: string;
}
